export const environment = {
    production: true,
    hostUrl: 'https://prod.explainapi.co.uk',
    apiUrl: 'https://prod.explainapi.co.uk/api/v1',
    whitelist: ['prod.explainapi.co.uk'],
    blacklist: ['/login'],
    primaryColor: '#1c7985',
    accentColor: '#c93457',
    masterGaId: 'G-49616536',
    environmentName: 'production',
    SocketIoUrl: 'https://sockets.explainapi.co.uk',
};

